import axios from 'axios';
import { put, takeLatest, call } from 'redux-saga/effects';
//types
import * as types from '../ActionTypes/BreakdownActionTypes';
//api
import { breakdown } from '../../BusinessLogic/Network/API/BreakdownsApi';
//action
import { BreakDownActionCreators } from '../ActionCreators/BreakdownActionCreators';

export class BreakdownSaga {
    static *getBreakDownById({ meta: { breakDownId } }) {
        try {
            const _breakdown = breakdown.create();
            const { data: response } = yield call(axios, _breakdown.getBreakDownById(breakDownId));

            yield put(BreakDownActionCreators.getBreakDownByIdSuccess(response.data));
        } catch (e) {
            console.log({ error: e });
        }
    }
}

export function* saga() {
    yield takeLatest(types.BREAKDOWN_GET_BY_ID_REQUEST, BreakdownSaga.getBreakDownById);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/BreakDownSaga.js